import * as api from './api';
import {fetchPpcConfigFulfilled, fetchPpcConfigRejected} from './actions';
import {isAxiosError} from '../types';

export const fetchPpcConfig = () => async (dispatch) => {
  try {
    const results = await api.fetchPPCData();
    if (results && !isAxiosError(results)) {
      dispatch(fetchPpcConfigFulfilled(results.data));
      return results;
    } else {
      dispatch(fetchPpcConfigRejected({error: results.data}));
    }
  } catch (exception) {
    dispatch(fetchPpcConfigRejected({error: exception}));
  }
  return undefined;
};

export const getDefaultRateCode = async (): Promise<number> => {
  const response = await api.fetchPPCData();
  return response.data?.['rateCode'];
};
